var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Navigation'),_vm._m(0),_c('Printables',{attrs:{"Category":"flyers"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section bg-primary-3"},[_c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v("Flyers")]),_c('div',{staticClass:"text-large"},[_vm._v("Edit, Download, Print.")])])])
}]

export { render, staticRenderFns }